import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

import spacing from '@decisiv/design-tokens/lib/spacing';
import color from '@decisiv/design-tokens/lib/color';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const Container = styled(Flex).attrs({ paddingX: 2, paddingY: 1 })`
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid ${toColorString(color.base.halfMoon)};

  /* 52px + 1px border */
  min-height: ${rem(spacing.base * 5.3)};
`;

export const Left = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 0.5)};
`;

export const Right = styled(Flex)`
  align-items: center;
`;
